import {BookingStatusNames, IBookingStatus} from "app/bookingStatusTypes";
import {BookingValidationItems} from "shared-services/booking-validation-service/bookingValidation.types";
import {
  IBooking,
  ICustomer,
  IDiarySchedule,
  IDiaryService,
  ITableItem,
  BookingMethods,
  BookingType,
  IBookingTime, IServiceItem,
} from "shared-types/index";
import {IBookingInfoAtTime} from "app/services/LegacyBookingAvailabilityService/types";


// could be a duplicate of ISectionMaxOcc (section.types.ts)
export interface ISectionItem {
  maxOccupancy?: number;
  _id: any; // can be 'any', so probably a string
  order: number;
  name: string;
}


export enum BookingNewCtrlStates {
  LOADING = 1,
  ENTER = 0,
  SUCCESS = 2,
  ERROR = 3,
  ERROR_LOADING = 4,
  SHOW_PAYMENT_URL = 5
}

export interface ITableDate extends IBookingTime, Date {
  state: string; // "selected"
}

export interface IServiceListItem {
  name: string;
  serviceIndex: number;
  service: any;
}


export interface IBookingInfoAtTimeExtended extends IBookingInfoAtTime {
  state?: string;
  table?: ITableItem;
}

// interface for newBooking.controller.js
export interface IBookingNewCtrl {
  bookingDuration?: number;
  openRepeatBookingTab: boolean;
  showBookingOption: boolean;
  booking: IBooking;
  customer: ICustomer;
  schedule: IDiarySchedule;
  service: IDiaryService;
  tableId: any;
  bookingTime: Date;
  bookingDate: Date;
  tableSection: any;
  selectedTime: IBookingInfoAtTimeExtended;
  state: BookingNewCtrlStates;
  bookingMethod: BookingMethods;
  bookingTimes?: IBookingInfoAtTimeExtended[];
  statusName: BookingStatusNames;
  statusOptions: IBookingStatus[];
  isNewBooking: boolean;
  serviceId: string;
  isBookingToMove: boolean;
  tableList: ITableItem[];
  serviceViewList: IServiceListItem[];
  selectedServiceFromHeader?: IServiceItem;
  updateTabs: (newValue?: any, oldValue?: any) => void;
  updateLables: () => void;
  nextTab: (bookingType?: BookingType) => void;
  bookingReactRerender: () => void;
  validationChecked: (includeScroll: boolean | BookingValidationItems[]) => void;
  setEmptyCustomer: () => void;
  toggleBookingOptions(skipNoPayment?: boolean): void;
}
